import { PublicOfferV2 } from '@luxuryescapes/contract-public-offer'

export default function getBedGroupsDescriptionsFromRates(rates: Array<PublicOfferV2.BedbankRate>) {
  return [...new Set(rates.flatMap(rate => rate.bedGroups.map(bg => bg.description)))].join(' or ')
}
